import { Badge, Box, Flex, Heading, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr } from '@chakra-ui/react'
import { OpenAccountsCardsProps } from '../interfaces/dashboard.interface'

const formatCurrency = (value: number) =>
  new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value)

// Função para cor do badge de dias em atraso
const getDaysOverdueBadge = (days: number) => {
  if (days >= 30) return 'red'
  if (days >= 15) return 'orange'
  return 'gray'
}

export const OpenAccountsCards = ({ data, totalOverdue, avgDaysOverdue }: OpenAccountsCardsProps) => {
  return (
    <Box bg="gray.700">
      <Flex alignItems="center" justifyContent="space-between" mb={6}>
        <Box>
          <Heading as="h3" size="md">
            Contas em Aberto
          </Heading>
          <Text fontSize="sm" color="white" mt={1}>
            {data.length} {data.length === 1 ? 'cliente inadimplente' : 'clientes inadimplentes'}
          </Text>
        </Box>
        <Box textAlign="right">
          <Text fontSize="sm" color="white">
            Total em Aberto
          </Text>
          <Text fontSize="2xl" fontWeight="bold" color="red.500">
            {formatCurrency(totalOverdue)}
          </Text>
          <Text fontSize="sm" color="white" mt={1}>
            Média: {avgDaysOverdue} dias em atraso
          </Text>
        </Box>
      </Flex>

      <TableContainer>
        <Table variant="simple">
          <Thead>
            <Tr>
              <Th color="white">Cliente</Th>
              <Th color="white">Documento</Th>
              <Th color="white" isNumeric>
                Valor Original
              </Th>
              <Th color="white" isNumeric>
                Juros/Multa
              </Th>
              <Th color="white" isNumeric>
                Total
              </Th>
              <Th color="white" textAlign="center">
                Dias em Atraso
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            {(data ?? []).map((account, index) => (
              <Tr key={index}>
                <Td fontWeight="medium">{account.client}</Td>
                <Td color="gray.500">{account.document}</Td>
                <Td isNumeric>{formatCurrency(account.originalValue)}</Td>
                <Td isNumeric color="orange.500">
                  {formatCurrency(account.fees)}
                </Td>
                <Td isNumeric fontWeight="semibold">
                  {formatCurrency(account.totalValue)}
                </Td>
                <Td textAlign="center">
                  <Badge colorScheme={getDaysOverdueBadge(account.daysOverdue)}>{account.daysOverdue} dias</Badge>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </Box>
  )
}

export default OpenAccountsCards
